import angular from 'angular';
import { ManagerSettingsModule } from '../../../settings/settings.module';
import { ValTypeMailgun } from './mailgun';

export const MailgunValidationDirectiveModule = angular.module('buildium.manager.validationDirectives.mailgun', [
    ManagerSettingsModule.name
])
    .directive('valTypeMailgun', ValTypeMailgun);
